export const getCouponQrInfo = async (token) => {
    const response = await fetch(`${process.env.PREACT_APP_API_URL}api/website/coupons/qr/${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });
    const json = await response.json();
    return {
        success: response.status === 200,
        data: json.data || null,
    };
};

export const verifyCouponByToken = async (token) => {
    const response = await fetch(`${process.env.PREACT_APP_API_URL}api/website/coupons/verify/${token}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({}),
    });
    const json = await response.json();
    return {
        success: response.status === 200,
        data: json.data || null,
    };
};
